export enum SpotMarketStatus {
  /**
   * The SpotMarket has been persisted but the invite emails have not yet
   * been dispatched to the carrier's recipients.
   */
  SENDING = 'SENDING',

  /**
   * An operations user has requested a bid from the carrier but the carrier has not responded yet
   */
  REQUESTED = 'REQUESTED',

  /**
   * The carrier has viewed the spot market but hasn't responded
   */
  VIEWED = 'VIEWED',

  /**
   * The carrier has submitted a bid in the spot market
   */
  ACCEPTED = 'ACCEPTED',

  /**
   * The carrier has rejected the spot market invite
   */
  REJECTED = 'REJECTED',

  /**
   * The spot market has expired
   */
  EXPIRED = 'EXPIRED',

  /**
   * The order/shipment has been assigned to a carrier
   */
  CLOSED = 'CLOSED',

  /**
   * All recipient email sends failed for this SpotMarket.
   */
  FAILED = 'FAILED',

  /**
   * An operations user has cancelled the spot market request.
   */
  CANCELLED = 'CANCELLED',
}

export const RESENDABLE_STATUSES = [
  SpotMarketStatus.REQUESTED,
  SpotMarketStatus.VIEWED,
  SpotMarketStatus.ACCEPTED,
  SpotMarketStatus.REJECTED,
  SpotMarketStatus.FAILED,
  SpotMarketStatus.EXPIRED,
  SpotMarketStatus.CANCELLED,
];

export const isResendableStatus = (
  spotMarketStatus?: SpotMarketStatus,
): boolean => {
  return !!spotMarketStatus && RESENDABLE_STATUSES.includes(spotMarketStatus);
};

export const COMPLETED_STATUSES = [
  SpotMarketStatus.REJECTED,
  SpotMarketStatus.EXPIRED,
  SpotMarketStatus.CLOSED,
  SpotMarketStatus.FAILED,
  SpotMarketStatus.CANCELLED,
];

export const isCompletedStatus = (
  spotMarketStatus?: SpotMarketStatus,
): boolean => {
  return !!spotMarketStatus && COMPLETED_STATUSES.includes(spotMarketStatus);
};
